jQuery(document).ready(function($){

    $('.home3__items').slick({
        dots: false,
        speed: 300,
        infinite: true,
        autoplay: true,
        fade: false,
        slidesToShow: 2,
        slidesToScroll: 2,
        autoplaySpeed: 5000,
        cssEase: 'ease-out',
        arrows: true,
        appendArrows: '.home3__arrows',
        prevArrow: '<button type="button" class="slick-prev"><i class="icon-chevron-left"></i></button>',
        nextArrow: '<button type="button" class="slick-next"><i class="icon-chevron-right"></i></button>',
        responsive: [
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    adaptiveHeight: true,
                }
            },
        ],
    });

    $('.home6__items').slick({
        dots: false,
        speed: 300,
        infinite: true,
        autoplay: true,
        fade: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplaySpeed: 5000,
        cssEase: 'ease-out',
        arrows: true,
        appendArrows: '.home6__arrows',
        prevArrow: '<button type="button" class="slick-prev"><i class="icon-chevron-left"></i></button>',
        nextArrow: '<button type="button" class="slick-next"><i class="icon-chevron-right"></i></button>',
        responsive: [
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            },
        ],
    });

    $('[data-video]').click(function(event) {
        var url = $(this).data('video');
        $('#modal-video').foundation('open');
        $('#modal-video video source').attr('src', url);
        var $el = $('#modal-video video')[0];
        $el.load();
        $el.play();
    });

    $('#modal-video').on('closed.zf.reveal', function(event) {
        var video = $(this).find('video')[0];

        if (!video.paused) {
            video.pause();
        }
    });

});
